module_nameRouting.$inject = ["$urlRouterProvider", "$stateProvider"];

function module_nameRouting($urlRouterProvider, $stateProvider) {
 $urlRouterProvider.otherwise("/index");
  $stateProvider
  .state({
  name:'index',
  url: '/index',
  controller: 'state_nameController',
  controllerAs: 'self',
  templateProvider: ['$q', ($q) => {
      return $q((resolve) => {
          require.ensure([], () => {
              let template = require('./state_name/views/index.html');
              resolve(template);
          });
      });
  }],
  resolve: {
      Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {
        let deferred = $q.defer();
        require.ensure([], function () {
            let module = require('./state_name/state_name.module');
            $ocLazyLoad.load({
                name: 'state_nameModule',
            });
            deferred.resolve(module);
        });
        
        return deferred.promise;
      }]
  }
    });
}

export default module_nameRouting;